import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageName:'',
    carrinho: [],
    desejos: [],
    images: {},
    imagensDeProduto:[],
    categoriasProdutos:{},
    configuracoesSite: {
      ocultar_preco_nao_logado: false,
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
